import React, { Component } from "react";
import Video from "./../Video/Video";

import { Docubytes } from "../../Model/Content"; //Include Home
import "./Docubytesplayertest.css";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import Stories from 'react-insta-stories';
import BarLoader from "react-spinners/BarLoader";
export default class Docubytesplayertest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      DataisLoaded: false,
      VirsionCheckData: "",
      VirsionCheckDataloaded: false,
      SearchClick: false,
      NotificationClick: false
    };
  }

  componentDidMount() {

    Docubytes(0, 100).then((res) => {

      this.setState({
        items: res.data,
        DataisLoaded: true,
      });
    });

  }

  render() {
    const contentStyle = {
      background: '#333',
      width: '100%',
      padding: 0,
      color: 'white',
      height: '100%'
    }

    if (this.state.DataisLoaded == false) {
      //  return <div className="loader"></div>;
      return <div className="loader"><BarLoader color="#ff000f" /></div>;
    }
    console.log(this.state.items)
    var data = this.state.items.message.contents;
    //const data = docubytes.contents;
    const stories2 = [
      {
        content: ({ action, isPaused }) => {
          return <div style={contentStyle}>

            <Video

              channel={data[0]['channel']}

              url={data[0]}

              Videodata={data[0]}
            />

          </div>
        }
      },
      {
        content: ({ action, isPaused }) => {
          return <div style={contentStyle}>

            <Video

              channel={data[2]['channel']}

              url={data[2]}

              Videodata={data[2]}
            />

          </div>
        }
      }
    ]
    return (
      <div className="App">
        <center>
          <div className="video-container" id="video-container">
            <div className="video-cards">
              <div className="stories">
                <Stories
                  loop
                  keyboardNavigation
                  defaultInterval={8000}
                  stories={stories2}
                  onStoryEnd={(s, st) => console.log('story ended', s, st)}
                  onAllStoriesEnd={(s, st) => console.log('all stories ended', s, st)}
                  onStoryStart={(s, st) => console.log('story started', s, st)}
                  width={'100%'}
                  height={'90%'}

                  storyContainerStyles={{ borderRadius: 8, overflow: 'hidden', maxWidth: '360px' }}
                />

              </div>
            </div>
          </div>
        </center>
        <Mobilemenu active="2" />
      </div>

    );
  }

}
